<div class="batch" [class.busy]="Loading || Posting">

  <!-- 1. what to pull -->
  <div class="controls">
    <div class="field f-date">
      <label>Created from</label>
      <rms-date name="From" label="" [(ngModel)]="From"></rms-date>
    </div>
    <div class="field f-date">
      <label>Created to</label>
      <rms-date name="To" label="" [(ngModel)]="To"></rms-date>
    </div>
    <div class="field">
      <label>Bank (new receipts)</label>
      <rms-select name="BankID" [options]="Banks" labelKey="BankName" valueKey="BankID" [(ngModel)]="BankID"></rms-select>
    </div>
    <div class="field">
      <label>Payment type (new receipts)</label>
      <rms-select name="PaymentDetailTypeID" [options]="DetailTypes" labelKey="DetailTypeName" valueKey="PaymentDetailTypeID"
                  placeholder="Select…" [(ngModel)]="PaymentDetailTypeID"></rms-select>
    </div>
    <button class="btn-bg-blue pull-btn" type="button" [disabled]="Loading || Posting" (click)="pull()">
      {{ Loading ? 'Reading Braintree…' : 'Pull from Braintree' }}
    </button>
  </div>

  @if (Environment === 'sandbox') {
  <div class="note">Braintree <b>sandbox</b> — test transactions, not Royal's real payments. Most rows will not match RMS.</div>
  }

  @if (Error) {
  <div class="save-error">{{ Error }}</div>
  }

  @if (Pulled) {
  <!-- 2. result summary (click to filter) -->
  <div class="summary">
    <span class="total">
      {{ Rows.length }} coffee transaction{{ Rows.length === 1 ? '' : 's' }}
      @if (Truncated) { <span class="warn"> (showing the first {{ Rows.length }} of {{ Total }} — narrow the dates)</span> }
    </span>
    <button type="button" class="chip r-all" [class.active]="Filter === 'ALL'" (click)="Filter = 'ALL'">All {{ Rows.length }}</button>
    @for (c of VisibleChips; track c.key) {
    <button type="button" class="chip {{ c.css }}" [class.active]="Filter === c.key" (click)="setFilter(c.key)">
      {{ c.label }} {{ count(c.key) }}
    </button>
    }
  </div>

  <!-- 3. the list -->
  <div class="table-scroll">
    <table class="grid-table">
      <thead>
        <tr>
          <th class="chk">
            <input type="checkbox" [checked]="AllShownSelected" (change)="toggleAllShown($any($event.target).checked)"
                   title="Tick / untick every row that can be posted" />
          </th>
          <th>Braintree ID</th>
          <th>Created</th>
          <th>Status</th>
          <th class="num">Amount</th>
          <th>Order #</th>
          <th>Customer</th>
          <th>Deposit</th>
          <th>Result</th>
          <th>Receipt #</th>
          <th>What happens / why</th>
        </tr>
      </thead>
      <tbody>
        @for (r of ShownRows; track r.TransactionId) {
        <tr [class.selected]="r.Selected && r.Action">
          <td class="chk">
            @if (r.Action) {
            <input type="checkbox" [(ngModel)]="r.Selected" [ngModelOptions]="{ standalone: true }" />
            }
          </td>
          <td class="mono">{{ r.TransactionId }}</td>
          <td class="nowrap">{{ r.CreatedAt | date: 'MM/dd/yyyy' }}</td>
          <td>{{ r.BtStatus }}</td>
          <td class="num" [class.neg]="r.TxnType !== 'sale'">{{ r.Amount | currency: 'USD' : 'symbol' : '1.2-2' }}</td>
          <td>{{ r.OrderID ?? r.OrderRef ?? '—' }}</td>
          <td class="cust">{{ r.CompanyName ?? '—' }}</td>
          <td class="nowrap">{{ r.DepositDate | date: 'MM/dd/yyyy' : 'UTC' }}</td>
          <td><span class="chip small {{ chipCss(r.Result) }}">{{ chipLabel(r.Result) }}</span></td>
          <td>{{ r.ChargeLogID ?? '' }}</td>
          <td class="msg">
            @if (r.Outcome) {
            <span class="outcome o-{{ r.Outcome.Outcome.toLowerCase() }}">{{ r.Outcome.Outcome }}</span>
            {{ r.Outcome.Message }}
            } @else {
            @if (r.Action) { <b>{{ actionLabel(r.Action) }}:</b> }
            {{ r.Message }}
            }
          </td>
        </tr>
        } @empty {
        <tr><td colspan="11" class="muted">No coffee transactions in Braintree for these dates.</td></tr>
        }
      </tbody>
    </table>
  </div>
  }

  <!-- 4. post -->
  <div class="actions">
    <span class="sel-info">
      @if (Selected.length) {
      {{ Selected.length }} ticked · {{ SelectedTotal | currency: 'USD' : 'symbol' : '1.2-2' }}
      }
    </span>
    <button class="btn-bg-slate" type="button" [disabled]="Posting" (click)="close()">Close</button>
    <button class="btn-bg-green" type="button" [disabled]="!Selected.length || Loading || Posting" (click)="confirmPost()">
      {{ Posting ? 'Posting…' : 'Post selected (' + Selected.length + ')' }}
    </button>
  </div>
</div>
